<div class="sidebar">
  @for (item of items; track $index) {
  <a [routerLink]="item.route" [class.active]="isActive(item)" class="opacity-50 hover:underline hover:opacity-100 hover:text-neutral">
    <img [src]="item.icon" />
    {{ item.title | translate }}
  </a>
  <hr class="my-4" />
  }
</div>
